<template>
    <div class="intro">
        <h1 class="title">
            CORE <br />
            COMPETENCIES
        </h1>
        <p>
            Here are the skills or languages that i acquired during my working
            experiences and also in my free time studying
        </p>
    </div>
    <div class="_swiper">
        <div @click="swiperInstance.slideNext()"><img src="@/assets/images/nav-up.webp" alt="" width="60" /></div>
        <swiper :direction="'vertical'" :loop="true" @swiper="onSwiper">
            <swiper-slide>
                <img src="@/assets/images/sliders/vue.webp" alt="" />
            </swiper-slide>
            <swiper-slide>
                <img src="@/assets/images/sliders/html.webp" alt="" />
            </swiper-slide>
            <swiper-slide>
                <img src="@/assets/images/sliders/lara.webp" alt="" />
            </swiper-slide>
            <swiper-slide>
                <img src="@/assets/images/sliders/bs.webp" alt="" />
            </swiper-slide>
            <swiper-slide>
                <img src="@/assets/images/sliders/css.webp" alt="" />
            </swiper-slide>
            <swiper-slide>
                <img src="@/assets/images/sliders/js.webp" alt="" />
            </swiper-slide>
            <swiper-slide>
                <img src="@/assets/images/skill_slider/ps_logo.webp" alt="" />
            </swiper-slide>
            <swiper-slide>
                <img src="@/assets/images/sliders/sass.webp" alt="" />
            </swiper-slide>
            <swiper-slide>
                <img
                    src="@/assets/images/sliders/figma.webp"
                    alt=""
                    style="width: 150px"
                />
            </swiper-slide>
            <swiper-slide>
                <img src="@/assets/images/sliders/php.webp" alt="" />
            </swiper-slide>
        </swiper>
        <div class="up" @click="swiperInstance.slidePrev()">
            <img
                src="@/assets/images/nav-up.webp"
                alt=""
                style="rotate: 180deg"
                width="60"
            />
        </div>
    </div>
</template>
<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import { ref } from "vue";
export default {
    components: { Swiper, SwiperSlide },
    setup() {
        const swiperInstance = ref();
        const onSwiper = (swiper) => {
            swiperInstance.value = swiper;
        };

        return {
            swiperInstance,
            onSwiper,
        };
    },
};
</script>
<style lang="scss" scoped>
.intro {
    padding: 0 8vw;
    .title {
        text-align: right;
        color: #ecb365;
    }
    p {
        color: #fff;
        font-weight: lighter;
    }
}
._swiper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 8vw;
}
.swiper {
    height: 40vh;
}
.swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
}
.swiper-slide img {
    width: 45vw;
}
</style>
